import React from 'react';
import type { LucideIcon } from 'lucide-react';

interface Props {
  icon?: LucideIcon;
  label: string;
  value: string | null | undefined;
  valueClass?: string;
}

export function Pill({ icon: Icon, label, value, valueClass }: Props) {
  return (
    <div className="flex flex-col items-start gap-0.5 px-2 py-1 border border-[var(--card-border)]">
      <div className="flex items-center gap-1">
        {Icon && <Icon className="w-3 h-3 cgm-text-muted" />}
        <span className="text-[10px] uppercase tracking-wide cgm-text-muted">{label}</span>
      </div>
      <span className={`text-sm font-medium ${valueClass ?? 'cgm-text-primary'}`}>
        {value || <span className="cgm-text-muted">N/A</span>}
      </span>
    </div>
  );
}
